import { Dates } from '../../packages/dates';
import Metadata from '../../requests/apa/Metadata';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import EpgPersistence from '../../AAF/Nepg/EpgPersistence';
import PureEpgTask from '../../requests/tasks/epg/PureEpgTask';
import store from '../../store';
import { showModal, MODAL_GENERIC } from '../../actions/modal';
import { showNotification } from '../../actions/notification';
import Translator from '../../requests/apa/Translator';
import Device from '../../devices/device';
import Utils from '../../utils/Utils';
import logger from 'src/utils/logger/logger';
export function parseFiltersResponse(response){
  return response.map( it => ({
    node_id: it.id,
    code: it.code,
    text: it.text,
  }));
}

export function parseLevelResponse(response){
  if(response &&
    Array.isArray(response.components) &&
    response.components[0] &&
    Array.isArray(response.components[0].items) &&
    response.components[0].items.length>0
  ){
    return response.components[0].items.map( channel => ({
      channel_url: channel.channel_url ? channel.channel_url : "tv://channel.00a0002a0002",
      cover: channel.cover,
      title: channel.title,
      group_id: channel.group_id,
      id: channel.id,
      provider: channel.provider, // Necesario para presentar modales de susc, en caso de
      timeshift: channel.timeshift ? channel.timeshift : null // en horas
    }));
  }
  return [];
}

export function parseGroupIdChannels(channels){
  return channels.map(channel=>channel.group_id);
}

export function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

export function parseTimeStringToMomentUnix(timeString){
  try{
    const year = timeString.substring(0,4);
    const month = timeString.substring(4,6);
    const day = timeString.substring(6,8);
    const hours = timeString.substring(8,10);
    const minutes = timeString.substring(10,12);
    const seconds = timeString.substring(12,14);
    return new Dates(`${year}-${month}-${day} ${hours}:${minutes}:${seconds}`).unix() ;
  }
  catch(e){
    logger.error('parseTimeStringToMoment catch e', e);
    return null;
  }
}

export function getMinutesToRetryInsertingEpg(){
  try{
    let metadataKey = Metadata.get('minutes_to_retry_inserting_epg','{"default":{"minutes":10}}');
    metadataKey = JSON.parse(metadataKey)
    const region = DeviceStorage.getItem('region');
    return metadataKey[region] || metadataKey['default'];
  }
  catch(e){
    return {minutes:10};
  }
}

export function getDaysToInsertEpg(){
  try{
    let metadataKey = Metadata.get('days_to_insert_epg','{"default":{"days":8}}');
    metadataKey = JSON.parse(metadataKey);
    const region = DeviceStorage.getItem('region');
    return metadataKey[region] || metadataKey['default'];
  }
  catch(e){
    return {days:8};
  }
}

export function getMinimumFutureDaysAvailableEpg(){
  try{
    let metadataKey = Metadata.get('minimum_future_days_available_epg',
      '{"default":{"days":6}}');
    metadataKey = JSON.parse(metadataKey)
    const region = DeviceStorage.getItem('region');
    return metadataKey[region] || metadataKey['default'];
  }
  catch(e){
    return {days:6};
  }
}

export function getMinimumPastDaysAvailableEpg(){
  try{
    let metadataKey = Metadata.get('minimum_past_days_available_epg',
      '{"default":{"days":1}}');
    metadataKey = JSON.parse(metadataKey)
    const region = DeviceStorage.getItem('region');
    return metadataKey[region] || metadataKey['default'];
  }
  catch(e){
    return {days:1};
  }
}

export function getDaysBeforeTodayToInsert(){
  try{
    let metadataKey = Metadata.get('days_before_today_to_insert',
      '{"default":{"days":1}}');
    metadataKey = JSON.parse(metadataKey)
    const region = DeviceStorage.getItem('region');
    return metadataKey[region] || metadataKey['default'];
  }
  catch(e){
    return {days:1};
  }
}

export function getEnableUpdateEpgButton(){
  try{
    if(EpgPersistence.isApiDataSource())
      return {enable:false};
    let metadataKey = Metadata.get('enable_update_epg_button',
      '{"default":{"enable":false}}');
    metadataKey = JSON.parse(metadataKey)
    const region = DeviceStorage.getItem('region');
    return metadataKey[region] || metadataKey['default'];
  }
  catch(e){
    return {enable:true};
  }
}

export function randn_bm() {
  var u = 0, v = 0;
  while(u === 0) u = Math.random(); //Converting [0,1) to (0,1)
  while(v === 0) v = Math.random();
  let num = Math.sqrt( -2.0 * Math.log( u ) ) * Math.cos( 2.0 * Math.PI * v );
  num = num / 10.0 + 0.5; // Translate to 0 -> 1
  if (num > 1 || num < 0) return randn_bm(); // resample between 0 and 1
  return num;
}

export function getPureEpgUrl(params){
  return new PureEpgTask(params).getUrlWithQueryParams();
}

export function showEpgUpdateProgress(updateProgressMessageType, percentage){
  const message = `${Translator.get('updating_epg_modal_message','Actualizando Guía de programación...')} ${parseInt(percentage)} %`;
  switch(updateProgressMessageType){
    case 'spinner':
      const divPercentage = document.getElementById('spinner-percentage');
      if(divPercentage){
        divPercentage.innerText = `${Translator.get('updating_epg_spinner_message','Cargando')} ${parseInt(percentage)} %`;
      }
      break;
    case 'modal':
      store.dispatch(showModal({
        modalType: MODAL_GENERIC,
        modalProps: {
          buttons: [
            {
              content:Translator.get("updating_epg_modal_accept_button_title", "Aceptar"),
              props: {
                onClick: () => {},
              }
            }
          ],
          content: message,
        }
      }));
      break;
    default: //nothing to do
  }
}

export function getMinutesToWakeUp(){
  try{
    let metadataKey = Metadata.get('minutes_to_wake_up','{"default":{"minutes":240}}');
    logger.debug('EpgFeederManager metadata value minutes_to_wake_up:' + metadataKey);
    metadataKey = JSON.parse(metadataKey)
    const region = DeviceStorage.getItem('region');
    return metadataKey[region] || metadataKey['default'];
  }
  catch(e){
    return {minutes:240};
  }
}

export function getInsertingTriesLimit(){
  try{
    let metadataKey = Metadata.get('inserting_tries_limit','{"default":{"limit":3}}');
    metadataKey = JSON.parse(metadataKey)
    const region = DeviceStorage.getItem('region');
    return metadataKey[region] || metadataKey['default'];
  }
  catch(e){
    return {limit:3};
  }
}

export function getOnEpgNoSuccessTimeout(){
  try{
    let metadataKey = Metadata.get('epg_no_success_timeout','{"default":{"minutes":3}}');
    metadataKey = JSON.parse(metadataKey)
    const region = DeviceStorage.getItem('region');
    return metadataKey[region] || metadataKey['default'];
  }
  catch(e){
    return {minutes:3};
  }
}

export function getOnEpgNoSuccessTriesLimit(){
  try{
    let metadataKey = Metadata.get('epg_no_success_tries_limit','{"default":{"limit":3}}');
    metadataKey = JSON.parse(metadataKey)
    const region = DeviceStorage.getItem('region');
    return metadataKey[region] || metadataKey['default'];
  }
  catch(e){
    return {limit:3};
  }
}

export function getHourRange(){
  try{
    let metadataKey = Metadata.get('hour_range_to_insert','{"default":{"hours":12}}');
    metadataKey = JSON.parse(metadataKey)
    const region = DeviceStorage.getItem('region');
    return metadataKey[region] || metadataKey['default'];
  }
  catch(e){
    return {hours:12};
  }
}

export function isVMayorIgual519(){
  let versionMayorIgual519 = false;
  let ua = navigator.userAgent;
  let apkVersion = null;
  if(ua) {
    let re = /(\d{3,})$/g;
    let res = re.exec(ua);
    if(res && res[1]) {
      apkVersion = parseInt(res[1]);
    }
  }
  if(apkVersion !== null) {
    versionMayorIgual519 = apkVersion >= 519;
  }

  return versionMayorIgual519;
}

export function isVMayorIgual520(){
  let versionMayorIgual520 = false;
  let ua = navigator.userAgent;
  let apkVersion = null;
  if(ua) {
    let re = /(\d{3,})$/g;
    let res = re.exec(ua);
    if(res && res[1]) {
      apkVersion = parseInt(res[1]);
    }
  }
  if(apkVersion !== null) {
    versionMayorIgual520 = apkVersion >= 520;
  }

  return versionMayorIgual520;
}


export function isVMayorIgual(FinalVersion){
  let versionMayorIgual = false;
  let ua = navigator.userAgent;
  let apkVersion = null;
  if(ua) {
    let re = /(\d{3,})$/g;
    let res = re.exec(ua);
    if(res && res[1]) {
      apkVersion = parseInt(res[1]);
    }
  }
  if(apkVersion !== null) {
    versionMayorIgual = apkVersion >= FinalVersion;
  }

  return versionMayorIgual;
}

export function isAndroidDevice(){
  return Device.getDevice().getPlatform() === 'android';
}

export function getUpdateEpgBlackList(){
  try{
    let metadataKey = Metadata.get('update_epg_black_list',
      '{"default":{"blackList":[]}}');
    metadataKey = JSON.parse(metadataKey);
    const region = DeviceStorage.getItem('region');
    return metadataKey[region] || metadataKey['default'];
  }
  catch(e){
    logger.error('getUpdateEpgBlackList e', e);
    return {blackList:[]};
  }
}

export function hourToMinutes(hour = "HH:mm") {
  var b = hour.split(':')
  return b[0]*60 + +b[1];
}

export function isHourBetweenRange(hour = "HH:mm", range = {initialLimit:"HH:mm",finalLimit:"HH:mm"}){
  logger.debug('[Utils] EpgFeederManager isHourBetweenRange hour' + hour + ', initialLimit', range.initialLimit, ', finalLimit', range.finalLimit);
  if(hour && range.initialLimit && range.finalLimit){
    const hourInMinutes = hourToMinutes(hour);
    const initialLimitInMinutes = hourToMinutes(range.initialLimit);
    const finalLimitInMinutes = hourToMinutes(range.finalLimit);
    logger.debug('[EpgFeederManager] isHourBetweenRange hourInMinutes', hourInMinutes);
    logger.debug('[EpgFeederManager] isHourBetweenRange initialLimitInMinutes', initialLimitInMinutes);
    logger.debug('[EpgFeederManager] isHourBetweenRange finalLimitInMinutes', finalLimitInMinutes);
    if( hourInMinutes >= initialLimitInMinutes  && hourInMinutes <= finalLimitInMinutes ){
      return true;
    }
  }
  return false;
}

export function convertMinutesToMilliseconds(minutes){
  return !isNaN(minutes) ? minutes * 60000 : 0;
}

export function getMomentNowFromSpecificHour(hour = '00:00:00'){
  const now = Utils.now(true), nowDay = now.date() ,nowMouth = now.month()+1 ,nowYear = now.year();
  return new Dates(`${nowYear}-${nowMouth}-${nowDay} ${hour}`);
}



// WEBPACK FOOTER //
// ./src/AAFPersistenceManager/helpers/Utils.js